import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ContentLoader from "react-content-loader";
import { useDispatch, useSelector } from "react-redux";
import { error } from "../../actions/alertAction";
import {
  getBillingShippingAddress,
  getCreditCards,
} from "../../actions/profileAction";
import {
  applySubscriptionPromoCode,
  clearSubscriptionPromoDetail,
  getSubscriptionList,
  getUserActiveSubscription,
  subscriptionPostAction,
} from "../../actions/subscriptionAction";
import BreadCrumb from "../../components/Breadcrumb";
import ConfirmDialog from "../../components/ConfirmDialog";
import { getUserDetail } from "../../utils/helper";
import history from "../../utils/history";
import AddressListPopup from "../Profile/AddressListPopup";
import CardListPopup from "../Profile/CardListPopup";
const Subscription = () => {
  const dispatch = useDispatch();

  const cardList = useSelector((state) => state.profile.cardList);
  const addressList = useSelector((state) => state.profile.addressList);
  const appLoading = useSelector((state) => state.alert.appLoading);
  const subscriptionList = useSelector(
    (state) => state.subscription.subscriptionList
  );
  const subscriptionInfo = useSelector(
    (state) => state.subscription.userActiveSubscription
  );
  const [selectedCard, setSelectedCard] = useState(null);
  const [selectedAddress, setSelectedAddress] = useState(null);
  const [showConfirmDialog, setShowConfirmDialog] = useState(false);
  const [activeSubscription, setActiveSubscription] = useState(null);
  const [selectedShippingAddress, setSelectedShippingAddress] = useState(null);
  const [showAddressModal, setShowAddressModal] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [cvvValue, setCvvValue] = useState("");
  const [isLoading, setIsLoading] = useState(true);
  const promoDetail = useSelector((state) => state.subscription.promoDetail);
  const [promoCode, setPromoCode] = useState("");
  const applyPromo = () => {
    dispatch(applySubscriptionPromoCode(promoCode));
  };

  const handleSubscribeUsingPromo = () => {
    const params = {
      params: {
        action: "addUserSubscriptionFromPromo",
        promo_code: promoCode,
        token: getUserDetail()?.token,
      },
    };
    dispatch(
      subscriptionPostAction(params, () => {
        dispatch(clearSubscriptionPromoDetail());
        history.push("/app");
      })
    );
  };

  const handleSubscribe = () => {
    if (!selectedAddress) {
      dispatch(error("Please choose billing address"));
      return;
    }

    if (!selectedCard) {
      dispatch(error("Please choose payment"));
      return;
    }
    if (activeSubscription) {
      if (cvvValue.length < 3 || isNaN(cvvValue) || cvvValue.length > 4) {
        dispatch(
          error(
            "Card Security Code must be numeric and 3-4 digits long in length"
          )
        );
        return;
      } else {
        const params = {
          params: {
            action: "addUserSubscription",
            subscriptionId: activeSubscription,
            addressId: selectedAddress.address_id,
            cc_id: selectedCard.cc_id,
            cvv: cvvValue,
            token: getUserDetail()?.token,
          },
        };
        dispatch(
          subscriptionPostAction(params, () => {
            history.push("/app");
          })
        );
      }
    } else {
      dispatch(error("Please select a subscription type"));
      return;
    }
  };

  const handleUpdate = () => {
    if (!selectedAddress) {
      dispatch(error("Please choose billing address"));
      return;
    }

    if (!selectedCard) {
      dispatch(error("Please choose payment"));
      return;
    }
    if (activeSubscription) {
      if (cvvValue.length < 3 || isNaN(cvvValue) || cvvValue.length > 4) {
        dispatch(
          error(
            "Card Security Code must be numeric and 3-4 digits long in length"
          )
        );
        return;
      } else {
        const params = {
          params: {
            action: "updateUserSubscription",
            subscriptionId: activeSubscription,
            addressId: selectedAddress.address_id,
            cc_id: selectedCard.cc_id,
            cvv: cvvValue,
            token: getUserDetail()?.token,
          },
        };
        dispatch(
          subscriptionPostAction(params, () => {
            setCvvValue("");
          })
        );
      }
    } else {
      dispatch(error("Please select a subscription type"));
      return;
    }
  };

  const handleUnSubscribe = () => {
    if (activeSubscription) {
      const params = {
        params: {
          action: "removeUserSubscription",
          subscriptionId: activeSubscription,
          token: getUserDetail()?.token,
        },
      };
      dispatch(
        subscriptionPostAction(params, () => {
          setActiveSubscription(null);
          dispatch(getSubscriptionList());
          dispatch(getUserActiveSubscription());
        })
      );
    } else {
      dispatch(error("Please select a subscription type"));
      return;
    }
  };

  useEffect(() => {
    dispatch(getSubscriptionList());
    dispatch(getCreditCards());
    dispatch(getBillingShippingAddress());
    dispatch(
      getUserActiveSubscription(() => {
        setIsLoading(false);
      })
    );
  }, [dispatch]);

  useEffect(() => {
    setCvvValue("");
  }, [selectedCard]);

  useEffect(() => {
    if (subscriptionList.length > 0 && subscriptionInfo) {
      subscriptionList.forEach((x) => {
        if (
          x.subscriptionId == subscriptionInfo.subscriptionId &&
          subscriptionInfo.statusId === 1
        ) {
          setActiveSubscription(x.subscriptionId);
        }
      });
    }
  }, [subscriptionInfo, subscriptionList]);
  useEffect(() => {
    if (cardList.length > 0) {
      if (selectedCard == null) {
        setSelectedCard(cardList[0]);
      }
    }
  }, [cardList]);

  useEffect(() => {
    if (addressList.length > 0) {
      if (selectedShippingAddress == null) {
        setSelectedShippingAddress(addressList[0]);
      }
      if (selectedAddress == null) {
        setSelectedAddress(addressList[0]);
      }
    }
  }, [addressList]);

  return (
    <div id="cart-page">
      {showAddressModal && (
        <AddressListPopup
          activeAddress={selectedAddress}
          setActiveAddress={setSelectedAddress}
          closePopup={() => setShowAddressModal(false)}
        />
      )}
      {showPaymentModal && (
        <CardListPopup
          setActiveCard={setSelectedCard}
          activeCard={selectedCard}
          closePopup={() => setShowPaymentModal(false)}
        />
      )}

      <BreadCrumb pageName={"Subscription"} />
      {showConfirmDialog && (
        <ConfirmDialog
          title="Are you sure want to remove subscription?"
          acceptAction={handleUnSubscribe}
          acceptText="yes"
          rejectText="no"
          closePopup={() => setShowConfirmDialog(false)}
        />
      )}
      <div className="row">
        <div className="col-sm-12">
          <h3 className="page-title">Subscription</h3>
          <p className="page-desc">Choose your subscription method.</p>
        </div>
      </div>

      <div className="row mt-2">
        <div className="col-md-12">
          <h5 className="profile-title">Subscription Type</h5>
          <hr />
          {!isLoading ? (
            <>
              <div className="subscription-items">
                {subscriptionList.map((x) => {
                  return (
                    <div
                      key={x.subscriptionId}
                      className={`text-center pricing-card--basic pricing-card ${
                        x.subscriptionId === activeSubscription ? "active" : ""
                      } `}
                      onClick={() => {
                        setActiveSubscription(x.subscriptionId);
                      }}
                    >
                      <span className="active-icon">
                        {x.subscriptionId === activeSubscription ? (
                          <FontAwesomeIcon icon={faCheckCircle} color="green" />
                        ) : null}
                      </span>
                      <h3 className="pricing-card__plan-name text-major heading--4">
                        {x.name}
                      </h3>
                      <div className="text-center pricing-card-content">
                        <p className="pricing-card__plan-description">
                          Duration: {x.duration} Month(s)
                        </p>
                        <div className="pricing-card__monthly-content">
                          <span className="pricing-card__plan-price heading--1">
                            <span className="price">
                              $<span className="price__number">{x.price}</span>
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          ) : (
            <>
              <ContentLoader viewBox="0 0 500 420" height={420} width={500}>
                <rect x="16" y="17" rx="0" ry="0" width="360" height="200" />
                <rect x="69" y="229" rx="2" ry="2" width="275" height="15" />
                <rect x="69" y="253" rx="2" ry="2" width="140" height="15" />
              </ContentLoader>
              <ContentLoader viewBox="0 0 500 420" height={420} width={500}>
                <rect x="16" y="17" rx="0" ry="0" width="360" height="200" />
                <rect x="69" y="229" rx="2" ry="2" width="275" height="15" />
                <rect x="69" y="253" rx="2" ry="2" width="140" height="15" />
              </ContentLoader>
            </>
          )}
        </div>

        <div className="col-md-6">
          <div className="row mt-2">
            <div className="col-md-12">
              <h5 className="profile-title">Billing Address</h5>
              <hr />
              {selectedAddress && (
                <p className="selectedItem">
                  {selectedAddress?.address_nickname
                    ? `${selectedAddress?.address_nickname} - `
                    : ""}
                  {selectedAddress?.address_1}
                  {", "}
                  {selectedAddress?.address_2 &&
                    `Apt ${selectedAddress?.address_2},`}{" "}
                  {selectedAddress?.city}, {selectedAddress?.state}{" "}
                  {selectedAddress?.zip}
                </p>
              )}
              <p
                className="small-btn"
                onClick={() => setShowAddressModal(true)}
              >
                Choose Other Address
              </p>
            </div>
          </div>
          <div className="row mt-2">
            <div className="col-md-12">
              <h5 className="profile-title">Payment Details</h5>
              <hr />
              {selectedCard && (
                <>
                  <p className="selectedItem">{selectedCard.name}</p>
                  <input
                    className="cvv"
                    type="number"
                    placeholder="Card Security Code*"
                    value={cvvValue}
                    onChange={(e) => {
                      if (e.currentTarget.value.length <= 4) {
                        setCvvValue(e.currentTarget.value);
                      }
                    }}
                  />
                  <div className="row col-md-12">
                    <OverlayTrigger
                      placement="right"
                      delay={{ show: 200, hide: 100 }}
                      overlay={
                        <Tooltip id="button-tooltip-2">
                          The 'Card Security Code' on your credit or debit card
                          is a 3 digit number on VISA®, MasterCard®, and
                          Discover® branded credit and debit cards located on
                          the back of the card. On your American Express®
                          branded credit or debit card it is a 4 digit numeric
                          code located on the front.
                        </Tooltip>
                      }
                    >
                      <p className="tip-text">What is it?</p>
                    </OverlayTrigger>
                  </div>
                </>
              )}

              <div className="row col-md-12 ">
                <p
                  className="small-btn"
                  onClick={() => setShowPaymentModal(true)}
                >
                  Choose Other Payment
                </p>
              </div>
            </div>
          </div>

          <div>
            {subscriptionInfo?.statusId !== 1 ? (
              <button
                disabled={appLoading}
                style={{ width: "15rem" }}
                className="btn btn-orange mt-2"
                onClick={handleSubscribe}
              >
                {" "}
                Subscribe{" "}
              </button>
            ) : (
              <div className="d-flex align-items-baseline">
                <button
                  disabled={appLoading}
                  style={{ width: "15rem" }}
                  className="btn btn-orange mt-2"
                  onClick={handleUpdate}
                >
                  {" "}
                  Update{" "}
                </button>
                <p
                  disabled={appLoading}
                  style={{
                    color: "#f79225",
                    marginLeft: "3rem",
                    cursor: "pointer",
                    textDecoration: "underline",
                  }}
                  onClick={() => setShowConfirmDialog(true)}
                >
                  {" "}
                  Unsubscribe{" "}
                </p>
              </div>
            )}
          </div>
        </div>
        <div className="col-md-6 mt-2">
          <div className="col-md-12">
            <h5 className="profile-title">Apply Promo Code</h5>
            <hr />
            {promoDetail && (
              <div>
                Promo code applied:
                <p className="page-desc">{promoDetail.display}</p>
              </div>
            )}
            <div className="promo">
              <p className="page-desc">Promo Code:</p>
              <input
                type="text"
                value={promoCode}
                onChange={(e) => setPromoCode(e.target.value)}
              />
              <button
                className="btn btn-orange promo-btn"
                disabled={promoCode?.length < 1}
                onClick={applyPromo}
              >
                {promoDetail ? "Change code" : "Apply"}
              </button>
            </div>
            {promoDetail && (
              <button
                disabled={appLoading}
                style={{ width: "15rem" }}
                className="btn btn-orange mt-2"
                onClick={handleSubscribeUsingPromo}
              >
                {" "}
                Subscribe Using Code{" "}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Subscription;
